import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";

/**
 * On first visit to "/", redirect to "/en" if browser language is not Finnish.
 */
const LanguageRedirect = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (location.pathname !== "/") return;
    const redirected = sessionStorage.getItem("lang-redirected");
    if (redirected) return;
    sessionStorage.setItem("lang-redirected", "1");

    // Never redirect bots, crawlers or headless/prerender environments
    if ((navigator as any).webdriver) return;
    const ua = (navigator.userAgent || "").toLowerCase();
    const isBot = /googlebot|bingbot|slurp|duckduckbot|baiduspider|yandex|facebookexternalhit|twitterbot|linkedinbot|discordbot|telegrambot|whatsapp|gptbot|chatgpt|perplexity|applebot|snapcrawl|headlesschrome|prerender|phantomjs|selenium/.test(ua);
    if (isBot) return;

    const browserLang = navigator.language || (navigator as any).userLanguage || "";
    if (!browserLang.startsWith("fi")) {
      navigate("/en", { replace: true });
    }
  }, [location.pathname, navigate]);

  return null;
};

export default LanguageRedirect;
